import axios from 'axios'
import qs from 'qs'
import router from '../router/'
import env, {apiLink} from '../config/'
import { v4 as uuidv4} from 'uuid';
import { getCookieItem, setCookieItem } from '@/network/storage';
import { Toast } from 'vant'

const baseURL = env.apiLink
const commonUrl = env.common

// 创建axios实例
const service = axios.create({
	baseURL,
	timeout: 50000, // 请求超时时间
	headers: {
		'lang-type': 'zh-CN'
	}
});

// request拦截器
service.interceptors.request.use(config => {
	// if(config.method === 'post'){
	// 	config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
	// }else if(config.method === 'get'){
	// 	config.headers['Content-Type'] = 'application/json;charset=UTF-8'
	// }

	let uuid = getCookieItem('uuid');
	if (!uuid) {
		uuid = uuidv4();
		setCookieItem('uuid', uuid);
	}
	config.headers['uuid'] = uuid;

	if(localStorage.getItem('accessToken')){
		// config.headers['	Authorization'] = `Bearer ${localStorage.getItem('token')}`
		config.headers['accessToken'] = localStorage.getItem('accessToken')
	}
	return config
}, err => {
	return Promise.reject(err)
});

// response拦截器
service.interceptors.response.use(res => {
	return res.data
}, err => {
	// axios接口服务器无法连接
	if(err.code){
		if(err.code == 'ERR_NETWORK' || err.code == 'ECONNABORTED'){
			// console.log(router.push({path: '/service-error.html'}))
		}
	}

	if(err.response.status == 403) {
		router.push({ path: '/login' })
		localStorage.removeItem('accessToken', '')
		Toast('请重新登录')
		return Promise.reject(err)
	}

	Toast(err.response.data.message)
	// Dialog.alert({
	// 	title: '系统提示',
	// 	message: err.response.data.message
	// })
	// console.log(err)
	return Promise.reject(err)
})

export default service


/**
 * get 请求方法
 * @param url
 * @param params
 * @returns {Promise}
 */
export function get(url, params = {}) {
	let header = { headers: {'Content-Type':'application/json;charset=UTF-8'} }
	return new Promise((resolve, reject) => {
		service.defaults.baseURL = baseURL;
		service.get(url, { params }, header).then(res => {
			if(res.code == 600){
				// TOKEN校验失败，进行重新登录
				localStorage.setItem('token', '')
				localStorage.setItem('rePath', router.history.current.path)
				localStorage.setItem('query', JSON.stringify(router.history.current.query))
				window.location.replace(window.location.origin + '/login')
				// reject(res)
			}else if(res.code == 602){
				// TOKEN已经过期，获取最新Token，重新重新请求
				reject(res)
			}else{
				resolve(res.result)
			}
		}).catch(err => {
			reject(err)
		})
	})
}

/**
 * post 请求方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function post(url, data = {}, type= true, isJson = false) {

	let params = isJson ? JSON.stringify(data) : qs.stringify(data)
	let header = type ? { headers: {'Content-Type': 'application/x-www-form-urlencoded'} } : { headers: {'Content-Type': 'application/json'} }

	return new Promise((resolve, reject) => {
		service.defaults.baseURL = baseURL;
		service.post(url, params, header).then(res => {
			resolve(res)
		}, err => {
			reject(err)
		})
	})
}

/**
 * common 请求方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function commonL(url, data = {}, type= true, isJson = false) {
	let params = isJson ? JSON.stringify(data) : qs.stringify(data)
	let header = type ? { headers: {'Content-Type': 'application/x-www-form-urlencoded'} } : { headers: {'Content-Type': 'application/json'} }

	return new Promise((resolve, reject) => {
		service.defaults.baseURL = commonUrl;
		service.post(url, params, header).then(res => {
			resolve(res)
		}, err => {
			reject(err)
		})
	})
}

